<template>
  <div>
    <z-container>
      <h3 class="text-body-1 mb-3">Recebimentos</h3>

      <v-row justify="center">
        <v-col cols="12">
          <v-card class="mb-3">
            <v-card-title class="text-subtitle-2">
              Filtro - Recebimentos
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text>
              <v-row dense>
                <v-col cols="12">
                  <v-autocomplete
                    filled
                    dense
                    clearable
                    placeholder=" "
                    v-model="filtro.cliente_id"
                    label="Cliente"
                    :items="$store.getters['listas/clientes']"
                    hide-details
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="3">
                  <v-select
                    filled
                    dense
                    placeholder=" "
                    clearable
                    :items="$globals.FORMAS_DE_PAGAMENTO"
                    v-model="filtro.forma_pagamento"
                    label="Forma de Pagamento"
                    hide-details
                  ></v-select>
                </v-col>
                <v-col cols="12" sm="3">
                  <z-date-picker-menu
                    filled
                    dense
                    clearable
                    v-model="filtro.data_inicial"
                    label="Vencimento Inicial"
                    placeholder=" "
                    hide-details
                  ></z-date-picker-menu>
                </v-col>
                <v-col cols="12" sm="3">
                  <z-date-picker-menu
                    filled
                    dense
                    clearable
                    v-model="filtro.data_final"
                    label="Vencimento Final"
                    placeholder=" "
                    hide-details
                  ></z-date-picker-menu>
                </v-col>
              </v-row>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text :disabled="recebimentos.length == 0" @click="imprimir">
                <v-icon left>mdi-printer</v-icon>
                Imprimir
              </v-btn>
              <v-btn depressed color="primary" @click="filtrar" :loading="loading">Filtrar</v-btn>
            </v-card-actions>
          </v-card>

          <v-card>
            <v-card-title class="text-subtitle-2">
              Recebimentos ({{ recebimentos.length }})
            </v-card-title>
            <v-divider></v-divider>

            <v-data-table
              id="recebimentos"
              item-key="id"
              disable-pagination
              hide-default-footer
              :items="recebimentos"
              :headers="headers.recebimentos"
              :loading="false"
              :search="search.recebimentos"
            >
              <template v-slot:item="{ item: recebimento }">
                <tr>
                  <td>{{ recebimento.data | dataBR }}</td>
                  <td>{{ recebimento.forma_pagamento }}</td>
                  <td>
                    {{ recebimento.cliente_id + " - " + recebimento.razao }}
                  </td>
                  <td class="text-right">{{ recebimento.valor | valorBR }}</td>
                </tr>
              </template>
              <template v-slot:body.append="{ items }">
                <tr>
                  <td colspan="4" class="text-right font-weight-bold">
                    {{ somaRecebimentos | valorBR }}
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </z-container>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapState, mapGetters } from "vuex";
import config from "@/app/config";
import qs from "qs";

export default {
  name: "RecebimentosLista",

  data() {
    return {
      filtro: {
        cliente_id: null,
        data_inicial: this.$moment()
          .startOf("month")
          .format("YYYY-MM-DD"),
        data_final: this.$moment()
          .endOf("month")
          .format("YYYY-MM-DD"),
        forma_pagamento: "",
      },
      search: {
        recebimentos: "",
      },
      headers: {
        recebimentos: [
          { text: "Data", value: "data", width: "120px" },
          { text: "Tipo", value: "forma_pagamento" },
          { text: "Cliente", value: "razao" },
          { text: "Valor", value: "valor", align: "right", width: "150px" },
          // { text: 'Opções', value:'', align: 'center', sortable: false }
        ],
      },
      loading: false,
      situacoes: [
        { text: "Todas", value: "Todas" },
        { text: "Em aberto", value: "Abertas" },
        { text: "Quitadas", value: "Pagas" },
        { text: "Vencidas", value: "Vencidas" },
        { text: "A Vencer", value: "AVencer" },
      ],
    };
  },

  inject: ["$imprimir"],

  computed: {
    ...mapState("financeiro", ["recebimentos"]),
    ...mapGetters("financeiro", ["somaRecebimentos"]),
  },

  mounted() {
    this.setTitulo("Recebimentos");
    this.$store.dispatch("listas/clientes");
  },

  beforeRouteLeave(to, from, next) {
    this.limparlistas();
    next();
  },

  methods: {
    ...mapMutations(["setTitulo", "LOADING_OFF"]),
    ...mapMutations("financeiro", ["limparlistas"]),
    ...mapActions("financeiro", ["filtrarRecebimentos"]),

    async filtrar() {
      try {
        this.loading = true;
        await this.filtrarRecebimentos(this.filtro);
      } catch (error) {
        this.$eventbus.erroSistema(error);
      } finally {
        this.loading = false;
      }
    },

    imprimir(pedido) {
      // this.abrirJanela(config.BASE_URL_PRINT + '/movimentos/'+ movimento.id +'/imprimir');
      // this.$imprimir(config.BASE_URL_PRINT + "/financeiro/recebimentos/imprimir?" + qs.stringify(this.filtro));
      this.abrirJanela(
        config.BASE_URL_PRINT +
          "/financeiro/recebimentos/imprimir?" +
          qs.stringify(this.filtro)
      );
      // this.PrintElem('pedidos');
    },
  },
};
</script>

<style scoped></style>
